// LICENSE_CODE ZON
'use strict'; /*jslint ts:true*/
// @ts-ignore
import zutil from '/util/util.js';
import hopt from 'hola_opt';
// @ts-ignore
import {qs_parse_url, get_root_domain, qs_str} from '/util/url.js';
// @ts-ignore
import cookie from 'cookie';
// @ts-ignore
import {get_json, set_json, get as get_ls, clr} from '/util/storage.js';
import {guess_browser} from 'zuser_agent';
// @ts-ignore
import {get} from '/util/util.js';
// @ts-ignore
import {cmp} from '/util/version_util.js';
// @ts-ignore
import {data} from 'loadTimeData';
import {guess_os_and_version} from './client_hints_global';
// @ts-ignore
import svc_util from '/svc/vpn/pub/util.js';
import config from 'pub_config';

interface i_conf_local {
    on: number;
    name?: string;
    is_active?: boolean;
    ignore_test?: boolean;
    ssr?: boolean;
    variants?: object_of<number>;
    ignore_active_for_send?: boolean;
    forced?: boolean;
    define_test_from_client?: boolean;
}
interface i_experiment_init {
    check_is_active: (checking_obj:object_of<string>,
        conf:i_conf_local)=>boolean;
    check_is_ignored: (checking_obj:object_of<string>,
        conf:i_conf_local)=>boolean;
    rand_select: (conf: i_conf_local|number, custom_rand?: number,
        selector?: (id:string)=>boolean)=>boolean;
    ui_test_conf: object_of<i_conf_local>;
    ui_test: object_of<boolean | string>;
    init_ui_tests: (props:object_of<any>, req:any,
        perr:(o:{id:string, info?: any})=>void)=>void;
    redefine_test: (test_name: string, value: boolean, host: string)=>void;
    move_it_to_cookie: (props: {host: string})=>void;
}
const experiment_init = {} as i_experiment_init;
experiment_init.check_is_active = function(checking_obj, conf){
    if (!conf.is_active)
        return true;
    if (!checking_obj)
    {
        const sys = guess_os_and_version();
        const b = guess_browser();
        if (b.edge)
            b.browser = 'edge';
        if (b.opera)
            b.browser = 'opera';
        const qs = qs_parse_url(window.location.href, {safe: true});
        checking_obj = {
            pathname: window?.location?.pathname,
            os: sys.os,
            os_version: sys.version,
            os_and_version: `${sys.os}_${sys.version}`,
            browser: b.browser,
            search: window?.location?.search||'',
            search_full: qs_str(qs),
        };
    }
    const props = Object.keys(conf.is_active);
    return props.every(p=>{
        // XXX dmitriiz: replace to dynamic
        const hola_uid = get(checking_obj, 'user.hola_uid', '')
            .replace(/\+/ig, '\\+');
        let value = conf.is_active[p];
        if (p=='has_event')
            return false;
        if (p=='tests')
        {
            if (!checking_obj.tests)
                return false;
            try {
                value = JSON.parse(value);
            } catch {
                return false;
            }
            const t_for_check = Object.keys(value);
            const res_v = t_for_check.every(t_name=>{
                return value[t_name]===checking_obj.tests[t_name];
            });
            return res_v;
        }
        if (p=='ext')
        {
            return svc_util.match_filter(Object.assign({now: Date.now()},
                config.get_hola_extension_info()), value);
        }
        const is_invers = value && value.not;
        if (is_invers)
            value = value.not;
        value = value.replace('[user.hola_uid]', hola_uid);
        const r_exp = new RegExp(value);
        if (is_invers)
            return !r_exp.test(get(checking_obj, p));
        if (p=='ext_version')
        {
            const current = get(checking_obj, p);
            return cmp(current, value) >= 0;
        }
        return r_exp.test(get(checking_obj, p));
    });
};
experiment_init.check_is_ignored = function(checking_obj, conf){
    if (!conf.ignore_test)
        return false;
    const props = Object.keys(conf.ignore_test);
    return props.every(p=>{
        // XXX dmitriiz: replace to dynamic
        const hola_uid = get(checking_obj, 'user.hola_uid', '')
            .replace(/\+/ig, '\\+');
        const ignore_value = conf.ignore_test[p].replace('[user.hola_uid]',
            hola_uid);
        const r_exp = new RegExp(ignore_value);
        return r_exp.test(get(checking_obj, p));
    });
};
const flatten_obj = function(obj, selector, key, res){
    res = res||{};
    if (!zutil.is_object(obj))
    {
        res[key.replace(/_/g, '.')] = obj;
        return res;
    }
    if (Object.keys(obj).includes('*'))
    {
        if (selector)
        {
            for (const k in obj)
            {
                if (selector(k))
                    return flatten_obj(obj[k], selector, key, res);
            }
        }
        return flatten_obj(obj['*'], selector, key, res);
    }
    for (const k in obj)
        flatten_obj(obj[k], selector, (key ? key+'_' : '')+k, res);
    return res;
};
experiment_init.rand_select = function(conf, custom_rand, selector){
    custom_rand = custom_rand||Math.random();
    if (!conf)
        return false;
    if (typeof conf!='object')
        return custom_rand<conf;
    if (conf.on)
        return custom_rand<conf.on;
    // complex multi option selector:
    // {opt1: {opt1_1: 0.4, opt1_2: 0.4}, opt2: 0.2}
    // will select only single branch and turn into one of:
    // {opt1: {opt1_1: true}} or
    // {opt1: {opt1_2: true}} or
    // {opt2: true}
    // @ts-ignore
    const flat_options = flatten_obj(conf, selector);
    // @ts-ignore
    const sorted = Object.entries(flat_options).sort((a, b)=>{
        if (a[1]>b[1])
            return -1;
        if (a[1]<b[1])
            return 1;
        return 0;
    });
    const match = sorted.find(([, prob])=>{
        // @ts-ignore
        if (custom_rand<prob)
            return true;
        // @ts-ignore
        custom_rand -= prob;
    });
    return match ? zutil.set({}, match[0], true) : false;
};
experiment_init.ui_test_conf = {};
experiment_init.ui_test = {};
experiment_init.redefine_test = function(test_name, value, host){
    const ui_test_conf_local = experiment_init.ui_test_conf;
    const conf = ui_test_conf_local[test_name];
    experiment_init.ui_test[test_name] = value;
    if (conf && conf.ssr)
    {
        let ui_testing_cookie = {} as object_of<i_conf_local>;
        try {
            // @ts-ignore
            ui_testing_cookie = JSON.parse(decodeURIComponent(cookie
                .get('ui_testing_ssr')));
        } catch {
            ui_testing_cookie = {};
        }
        if (!ui_testing_cookie)
            ui_testing_cookie = {};
        // @ts-ignore
        ui_testing_cookie[test_name] = value;
        ui_testing_cookie[test_name+'_conf'] = {...conf};
        if (ui_testing_cookie[test_name+'_conf'])
            ui_testing_cookie[test_name+'_conf'].forced = true;
        cookie.set('ui_testing', JSON.stringify(ui_testing_cookie), {
            domain: `.${get_root_domain(host)}`,
        });
        cookie.set('ui_testing_ssr', JSON.stringify(ui_testing_cookie), {
            domain: `.${get_root_domain(host)}`,
        });
    }
    else
    {
        const ui_testing = get_json('ui_testing') || {};
        ui_testing[test_name] = value;
        set_json('ui_testing', ui_testing);
    }
};
function apply_browser_test(tests, ui_test_local, qs){
    const tests_keys = Object.keys(tests);
    tests_keys.forEach(key=>{
        const value = tests[key];
        const qs_param = +qs[`debug_${key}`];
        ui_test_local[key] = value == 'OFF_FOR_ALL' || value == 'OFF' ? false :
            true;
        ui_test_local[key+'_conf'] = {
            on: value == 'OFF_FOR_ALL' ? 0 :
                value == 'OFF' ? 0.5 :
                value == 'ON' ? 0.5 : 1,
        };
        if (qs_param)
            ui_test_local[key] = true;
        else if (qs_param===0)
            ui_test_local[key] = false;
    });
}
experiment_init.init_ui_tests = function(props, req, perr){
    let ui_test_conf_local = experiment_init.ui_test_conf;
    let ui_test_local = experiment_init.ui_test;
    if (req)
    {
        ui_test_conf_local = req.ui_test_conf = {};
        ui_test_local = req.ui_test = {};
    }
    Object.assign(ui_test_conf_local,
        zutil.get(hopt, 'www_hola.ui_tests') || {});
    const ui_testing = !req && get_json('ui_testing') || {};
    const cookie_value_parsed = props?.cookie_value_parsed || {
        pers: true,
        perf: true,
        mark: true,
        n: true,
    };
    const is_ui_t_cookie_allowed = cookie_value_parsed.pers ||
        cookie_value_parsed.perf || cookie_value_parsed.mark;
    let ui_testing_cookie = {} as object_of<i_conf_local>;
    try {
        if (is_ui_t_cookie_allowed)
        {

            // XXX dmitriiz: if we are on browser we should take "prepared"
            // cookie from server and save it in proper cookie
            // after UI loaded
            // @ts-ignore
            ui_testing_cookie = JSON.parse(decodeURIComponent(cookie
                .get('ui_testing_ssr')));
        }
        else
            ui_testing_cookie = !req && get_json('ui_testing_c') || {};
    } catch {
        ui_testing_cookie = {};
    }
    if (!ui_testing_cookie)
        ui_testing_cookie = {};
    const sys = props?.client_hints?.platform || guess_os_and_version();

    const b = guess_browser();
    if (b.edge)
        b.browser = 'edge';
    if (b.opera)
        b.browser = 'opera';
    // get ext version from chromium
    // there will be latest version on release date
    // it will provide to us know min version before extension installed
    let ext_version = data.ext_version;
    try {
        ext_version = window.document.documentElement
            .getAttribute('hola_ext_version');
    } catch {}
    // in ssr we setup global.window = global
    // in ss_render.js file
    const qs = qs_parse_url(req && req.url || window.location.href,
        {safe: true});
    const search = window.location && window.location.search || '';
    const checking_base = {
        pathname: req && req.path || window.location.pathname,
        os: sys.os,
        os_version: sys.version,
        os_and_version: `${sys.os}_${sys.version}`,
        browser: b.browser,
        search,
        search_full: qs_str(qs),
        ext_version: ext_version || qs.ext_version,
    };
    const checking_obj = Object.assign({}, checking_base, props);
    function is_testing(id, testing_obj){
        try {
            let conf = ui_test_conf_local[id];
            checking_obj.tests = ui_test_local;
            if (!conf)
                conf = {on: 0};
            const conf_res = typeof conf=='object' ? conf.on || 0 : conf;
            const for_check = testing_obj[id+'_conf'] ?
                {...testing_obj[id+'_conf']} : {};
            let was_forced_set = false;
            if (for_check)
            {
                was_forced_set = for_check.forced;
                delete for_check.forced;
            }
            if (for_check.dont_redefine_by_active)
                was_forced_set = true;
            // @ts-ignore
            if (conf_res===0 || conf_res===false)
            {
                delete testing_obj[id+'_conf'];
                delete testing_obj[id];
                return null;
            }
            if (!req && typeof conf=='object' && conf.ssr && id in testing_obj)
                return testing_obj[id];
            if (!was_forced_set
                && experiment_init.check_is_ignored(checking_obj, conf)
                && !conf.ignore_active_for_send)
            {
                delete testing_obj[id+'_conf'];
                delete testing_obj[id];
                return null;
            }
            if (!was_forced_set
                && !experiment_init.check_is_active(checking_obj, conf)
                && !conf.ignore_active_for_send)
            {
                delete testing_obj[id+'_conf'];
                delete testing_obj[id];
                return null;
            }
            // @ts-ignore
            if (!conf.variants && (conf_res===1 || conf_res===true))
                return true;
            if (id in testing_obj
                && zutil.equal_deep(for_check, conf))
            {
                return testing_obj[id];
            }
            if (!experiment_init.check_is_active(checking_obj, conf))
                return null;
            // @ts-ignore
            let res = experiment_init.rand_select(conf.variants || conf_res);
            if (conf.variants) // @ts-ignore
                res = res ? Object.keys(res)[0] : res;
            testing_obj[id+'_conf'] = conf;
            return testing_obj[id] = res;
        } catch {
            if (perr)
                perr({id: 'www_premium_payment_invalid_ui_testing'});
        }
    }
    const tests_all = Object.keys(ui_test_conf_local);
    const tests = [];
    const added_tests = {};
    const tests_for_set_from_ui = [];
    tests_all.forEach(key=>{
        const conf = ui_test_conf_local[key];
        // @ts-ignore
        if (conf && conf.is_active && conf.is_active.tests)
        {
            // @ts-ignore
            const tests_before = Object.keys(conf.is_active.tests);
            // XXX dmitriiz: not doing it complex. No need check to circle deps
            tests_before.forEach(t=>{
                if (!added_tests[t])
                {
                    added_tests[t] = true;
                    tests.push(t);
                }
            });
        }
        if (!added_tests[key])
        {
            added_tests[key] = true;
            tests.push(key);
        }
        if (conf.define_test_from_client)
            tests_for_set_from_ui.push(key);
    });
    tests.forEach(key=>{
        const ls_val = get_ls(`debug_${key}`);
        const ls_number = ls_val!==null && ls_val!==undefined ?
            +ls_val : undefined;
        const qs_param = +qs[`debug_${key}`] || ls_number;
        ui_test_local[key] = is_testing(key, ui_test_conf_local[key].ssr
            ? ui_testing_cookie : ui_testing);
        if (qs_param)
            ui_test_local[key] = true;
        else if (qs_param===0)
            ui_test_local[key] = false;
    });
    let tests_from_browser_qs = {};
    try {
        tests_from_browser_qs =
            JSON.parse(decodeURIComponent(qs.browser_experiments));
    } catch {}
    let tests_from_browser_data = {};
    try {
        tests_from_browser_data =
            JSON.parse(decodeURIComponent(data.browser_experiment));
    } catch {}
    let tests_from_svc = {};
    try {
        const svc_ab = data.svc_ab_tests;
        const svc_tests = svc_ab.split(',');
        svc_tests.forEach(svc_t=>{
            const is_on = svc_t.indexOf('_on') == svc_t.length - 3;
            const t_name = is_on ? svc_t.split('_on')[0]
                : svc_t.split('_off')[0];
            tests_from_svc[t_name] = is_on ? 'ON' : 'OFF';
        });
    } catch {}
    if (qs?.ref)
    {
        qs.ref.split('test_').filter(el=>/_on|_off/.test(el)).map(el=>{
            const on = !!/_on/.test(el);
            const name = on ? el.split('_on')[0]
                : el.split('_off')[0];
                ui_test_local[`test_${name}`] = on;
        });
    }
    apply_browser_test(tests_from_browser_qs, ui_test_local, qs);
    apply_browser_test(tests_from_browser_data, ui_test_local, qs);
    apply_browser_test(tests_from_svc, ui_test_local, qs);
    if (!req)
        set_json('ui_testing', ui_testing);
    if (props.host && Object.keys(ui_testing_cookie).length > 0)
    {
        if (is_ui_t_cookie_allowed)
        {
            try {
                const current_cookie = cookie.get('ui_testing');
                const new_cookie = JSON.stringify(ui_testing_cookie);
                if (current_cookie != new_cookie && perr)
                {
                    perr({id: 'www_ui_testing_ssr_assigned', info: {
                        new_cookie: ui_testing_cookie,
                    }});
                }
            } catch {}

            cookie.set('ui_testing_ssr', JSON.stringify(ui_testing_cookie),
            {
                domain: `.${get_root_domain(props.host)}`,
            });
            if (!req)
            {
                cookie.set('ui_testing', JSON.stringify(ui_testing_cookie),
                {
                    domain: `.${get_root_domain(props.host)}`,
                });
            }
        }
        else if (!req)
            set_json('ui_testing_c', ui_testing_cookie);
    }
    else if (props.host)
    {
        if (is_ui_t_cookie_allowed)
        {
            cookie.set('ui_testing_ssr', JSON.stringify({}), {
                domain: `.${get_root_domain(props.host)}`,
            });
            cookie.set('ui_testing', JSON.stringify({}), {
                domain: `.${get_root_domain(props.host)}`,
            });
        }
        else if (!req)
            set_json('ui_testing_c', {});
    }
    experiment_init.ui_test = ui_test_local;
    experiment_init.ui_test_conf = ui_test_conf_local;
};
experiment_init.move_it_to_cookie = props=>{
    const ui_testing_cookie = get_json('ui_testing_c') || {};
    if (props.host && Object.keys(ui_testing_cookie).length > 0)
    {
        cookie.set('ui_testing_ssr', JSON.stringify(ui_testing_cookie), {
            domain: `.${get_root_domain(props.host)}`,
        });
    }
    else if (props.host)
    {
        cookie.set('ui_testing_ssr', JSON.stringify(ui_testing_cookie), {
            domain: `.${get_root_domain(props.host)}`,
        });
    }
    clr('ui_testing_c');
};

export default experiment_init;
